<script>
export default {
    name: "PostedBillsPrint",

    data() {

        return {
            patients: [],
        };
    },

    computed: {

        totalBillAmount() {
            if(!this.patients.length) return 0;

            return this.patients.map(patient => patient.totalAmount ? parseFloat(patient.totalAmount) : 0)
                .reduce((sum, amt) => sum + amt);
        },

        totalCashAmount() {
            if(!this.patients.length) return 0;

            return this.patients.map(patient => patient.cash ? parseFloat(patient.cash) : 0)
                .reduce((sum, amt) => sum + amt);
        },

        totalDepositAllocated() {
            if(!this.patients.length) return 0;

            return this.patients.map(patient => patient.deposit ? parseFloat(patient.deposit) : 0)
                .reduce((sum, amt) => sum + amt);
        },

        totalInvoicedAmount() {
            if(!this.patients.length) return 0;

            return this.patients.map(patient => patient.insurance ? parseFloat(patient.insurance) : 0)
                .reduce((sum, amt) => sum + amt);
        },

        totalWeiveredAmount() {
            if(!this.patients.length) return 0;

            return this.patients.map(patient => patient.weivered ? parseFloat(patient.weivered) : 0)
                .reduce((sum, amt) => sum + amt);
        },

        totalBalance() {
            if(!this.patients.length) return 0;

            return this.patients.map(patient => patient.balance ? parseFloat(patient.balance) : 0)
                .reduce((sum, amt) => sum + amt);
        },
    },

    mounted() {

        Promise.allSettled([ this.fetchPostedBills(), ]).then(() => {
            window.print();
            window.onafterprint = function() { window.close(); }
        }).catch(() => {});
    },

    methods: {

        fetchPostedBills() {

            let url = `AccountsReports/GetPostedBillsReport?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            url += this.$route.query.user ? `&User=${this.$route.query.user}` : ``;

            return this.$http.get(url).then(response => {
                this.patients = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full my-2 text-center">
            <h5 class="font-medium">Posted patient bills Report</h5>
        </div>
        <table class="table table-striped">
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex">
                      <th scope="row" class="p-tiny w-1/5">Patient</th>
                      <th scope="row" class="p-tiny w-1/6">IPFile No</th>
                      <th scope="row" class="p-tiny w-1/6">OPFile No</th>
                      <th scope="row" class="p-tiny w-1/6">Bill No</th>
                      <th scope="row" class="p-tiny w-1/6">Posted By</th>
                      <th scope="row" class="p-tiny w-1/6">Amount</th>
                      <th scope="row" class="p-tiny w-1/6">Cash</th>
                      <th scope="row" class="p-tiny w-1/6">Deposit</th>
                      <th scope="row" class="p-tiny w-1/6">Insurance</th>
                      <th scope="row" class="p-tiny w-1/6">Weivered</th>
                      <th scope="row" class="p-tiny w-1/6">Balance</th>
                  </tr>
                <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                    <td class="p-tiny w-1/5">{{ patient.patient }}</td>
                    <td class="p-tiny w-1/6">{{ patient.ipfileno }}</td>
                    <td class="p-tiny w-1/6">{{ patient.opfileno }}</td>
                    <td class="p-tiny w-1/6">{{ patient.bill_No }}</td>
                    <td class="p-tiny w-1/6">{{ patient.userName }}</td>
                    <td class="p-tiny w-1/6">{{ patient.totalAmount | numberFormat }}</td>
                    <td class="p-tiny w-1/6">{{ patient.cash | numberFormat }}</td>
                    <td class="p-tiny w-1/6">{{ patient.deposit | numberFormat }}</td>
                    <td class="p-tiny w-1/6">{{ patient.insurance | numberFormat }}</td>
                    <td class="p-tiny w-1/6">{{ patient.weivered | numberFormat }}</td>
                    <td class="p-tiny w-1/6">{{ patient.balance | numberFormat }}</td>
                </tr>
                <tr class="w-full flex font-medium text-base">
                    <td class="p-tiny w-1/6">Bills: {{ totalBillAmount | numberFormat }}</td>
                    <td class="p-tiny w-1/6">Cash: {{ totalCashAmount | numberFormat}}</td>
                    <td class="p-tiny w-1/6">Deposit Allocated: {{ totalDepositAllocated | numberFormat }}</td>
                    <td class="p-tiny w-1/6">Invoiced: {{ totalInvoicedAmount | numberFormat }}</td>
                    <td class="p-tiny w-1/6">Weivered: {{ totalWeiveredAmount | numberFormat }}</td>
                    <td class="p-tiny w-1/6">Balance: {{ totalBalance | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>